import valueReducer from '../../../../common/reducers/valueReducer';
import { SET_HANDOFF } from '../../constants';

export default valueReducer(
  true,
  [SET_HANDOFF],
);
